import { useMutation } from '@tanstack/react-query';

import image, { preSignedUrlParams } from '@/api/image';

const useUploadImage = () => {
  return useMutation((params: preSignedUrlParams) => image.uploadImage(params));
};

export default useUploadImage;
